export const getElementStylePropertyNum = (selector, propertyName) => {
    const el = document.querySelector(selector);
    if (el)
        return parseFloat(window.getComputedStyle(el, null).getPropertyValue(propertyName));
    return 100;
};
